// import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  vant.Toast.loading({
    duration: 0,
    message: "加载页面中...",
    forbidClick: true,
  });
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: [
    // {
    //   path: '',
    //   redirect: '/h5/index/index',
    // },
    // {
    //   path: '/h5/tiku/index',
    //   name: 'tikuindex',
    //   component: () => import('@/page/index/tiku.vue'),
    //   meta: {
    //   }
    // },
    // {
    //   path: '/h5/my/index',
    //   name: 'my',
    //   component: () => import('@/page/my/index.vue'),
    //   meta: {
    //   }
    // },
    // {
    //   path: '/h5/shop/index',
    //   name: 'shopIndex',
    //   component: () => import('@/page/shop/index.vue'),
    //   meta: {
    //   }
    // },
    {
      path: '/h5/goods',
      name: 'goods',
      component: () => import('@/page/goods.vue'),
      meta: {
        assign: true,
        is_login: true
      },
      beforeEnter(to, from, next) {
        if (to.query.tpl && to.query.time) {
          next({
            path: "/h5/getCoupon2",
            query: to.query
          })
        } else {
          next()
        }
      }
      // children: [{
      //   path: 'whole',
      //   component: () => import('@/page/goods/whole.vue'),
      // }]
    },
    {
      path: '/h5/goods/whole',
      component: () => import('@/page/goods/whole.vue'),
      meta: {
        is_login: true
      },
    },
    {
      path: '/h5/group',
      name: 'Collage',
      component: () => import('@/page/group.vue'),
      meta: {
        assign: true,
        is_login: true
      },
      beforeEnter: (to, from, next) => {
        next()
      }
    },
    {
      path: '/h5/test/test',
      name: 'test',
      component: () => import('@/page/test/test.vue'),
      meta: {
        assign: true
      },
      beforeEnter: (to, from, next) => {
        next()
      }
    },
    {
      path: '/h5/whole',
      name: 'whole',
      component: () => import('@/page/whole.vue')
      ,
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/address',
      name: 'address',
      component: () => import('@/page/address.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/addressEidt',
      name: 'addressEidt',
      component: () => import('@/page/addressEidt.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/pay',
      name: 'pay',
      component: () => import('@/page/pay.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/rule',
      name: 'rule',
      component: () => import('@/page/rule.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/appDownload',
      name: 'appDownload',
      component: () => import('@/page/appDownload.vue'),
      meta: {
        assign: true,
        is_login: true
      }
    },
    {
      path: '/h5/download',
      name: 'download',
      component: () => import('@/page/download.vue'),
      meta: {
        assign: true,
        is_login: true
      }
    },
    {
      path: '/h5/success',
      name: 'success',
      component: () => import('@/page/success.vue'),
      meta: {
        assign: true,
        is_login: true
      }
    },
    {
      path: '/h5/set',
      name: 'set',
      component: () => import('@/page/set.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/tiku/searce',
      name: 'searce',
      component: () => import('@/page/index/searce.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiDan/detail',
      name: 'detail',
      component: () => import('@/page/tiDan/detail.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiDan/clearance',
      name: 'clearance',
      component: () => import('@/page/tiDan/clearance.vue'),
      meta: {
      }
    },
    {
      path: '/h5/power',
      name: 'power',
      component: () => import('@/page/power.vue'),
      meta: {
      }
    },

    {
      path: '/h5/tiDan/tiDan',
      name: 'tiDan',
      component: () => import('@/page/tiDan/tiDan.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiku/addTiku',
      name: 'addTiku',
      component: () => import('@/page/tiku/addTiku.vue'),
      meta: {
      }
    }, {
      path: '/h5/tiku/addTikuS',
      name: 'addTikuS',
      component: () => import('@/page/tiku/addTikuS.vue'),
      meta: {
      }
    }, {
      path: '/h5/information/detail',
      name: 'detail',
      component: () => import('@/page/information/detail.vue'),
      meta: {
      }
    },
    {
      path: '/h5/goods/agreement',
      name: 'agreement',
      component: () => import('@/page/goods/agreement.vue'),
      meta: {
        is_login: true
      },
    },
    {
      path: '/h5/my/sysnews',
      name: 'sysnews',
      component: () => import('@/page/my/sysnews.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/Drying',
      name: 'Drying',
      component: () => import('@/page/my/Drying.vue'),
      meta: {
      }
    }, {
      path: '/h5/my/logistics',
      name: 'logistics',
      component: () => import('@/page/my/logistics.vue'),
      meta: {
      }
    }, {
      path: '/h5/tiku/choice',
      name: 'choice',
      component: () => import('@/page/tiku/choice.vue'),
      meta: {
      }
    }, {
      path: '/h5/tiku/topic',
      name: 'topic',
      component: () => import('@/page/tiku/topic.vue'),
      meta: {
      }
    }, {
      path: '/h5/comment/index',
      name: 'comment',
      component: () => import('@/page/comment/index.vue'),
      meta: {
      }
    }, {
      path: '/h5/tiku/correction',
      name: 'correction',
      component: () => import('@/page/tiku/correction.vue'),
      meta: {
      }
    }, {
      path: '/h5/comment/Reply/:comment_id',
      name: 'Reply',
      component: () => import('@/page/comment/Reply.vue'),
      meta: {
      }
    }, {
      path: '/h5/comment/explain',
      name: 'commentexplain',
      component: () => import('@/page/comment/explain.vue'),
      meta: {
      }
    },

    {
      path: '/h5/tiku/year',
      name: 'year',
      component: () => import('@/page/tiku/year.vue'),
      meta: {
      }
    },
    {
      path: '/h5/DaKaRiLi/index',
      name: 'DaKaRiLi/index',
      component: () => import('@/page/DaKaRiLi/index.vue'),
      meta: {
      }
    },
    {
      path: '/h5/DaKaRiLi/rule',
      name: 'DaKaRiLi/rule',
      component: () => import('@/page/DaKaRiLi/rule.vue'),
      meta: {
      }
    },
    {
      path: '/h5/DaKaRiLi/weixin',
      name: 'DaKaRiLi/weixin',
      component: () => import('@/page/DaKaRiLi/weixin.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiku/result',
      name: 'result',
      component: () => import('@/page/tiku/result.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiku/cuoti',
      name: 'cuoti',
      component: () => import('@/page/ad/cuoti.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiku/biji',
      name: 'biji',
      component: () => import('@/page/ad/biji.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiku/pinglun',
      name: 'pinglun',
      component: () => import('@/page/ad/pinglun.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiku/shoucang',
      name: 'shoucang',
      component: () => import('@/page/ad/shoucang.vue'),
      meta: {
      }
    },
    {
      path: '/h5/shop/tabs',
      name: 'tabs',
      component: () => import('@/page/shop/tabs.vue'),
      meta: {
      }
    },
    {
      path: '/h5/login',
      name: 'login',
      component: () => import('@/page/login/login.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/introduction',
      name: 'introduction',
      component: () => import('@/page/login/introduction.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/about',
      name: 'about',
      component: () => import('@/page/login/about.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/logout',
      name: 'logout',
      component: () => import('@/page/login/logout.vue'),
      meta: {
        is_login: true
      }
    },

    {
      path: '/h5/Licencecenter',
      name: 'Licencecenter',
      component: () => import('@/page/login/Licencecenter.vue'),
      meta: {
        is_login: true
      }
    },

    {
      path: '/h5/login/register',
      name: 'register',
      component: () => import('@/page/login/register.vue'),
      meta: {
        is_login: true
      }
    }, {
      path: '/h5/login/password',
      name: 'password',
      component: () => import('@/page/login/password.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/agreement',
      name: 'loginagreement',
      component: () => import('@/page/login/agreement.vue'),
      meta: {
        is_login: true
      }
    }, {
      path: '/h5/Privacy',
      name: 'Privacy',
      component: () => import('@/page/login/Privacy.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/tiku/random',
      name: 'random',
      component: () => import('@/page/tiku/random.vue'),
      meta: {
      }
    },

    {
      path: '/h5/userMy/:user_id',
      name: 'userMy',
      component: () => import('@/page/userMy.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiku/biji_detail',
      name: 'biji_detail',
      component: () => import('@/page/ad/biji_detail.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiku/exam',
      name: 'exam',
      component: () => import('@/page/tiku/exam.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiku/exam2',
      name: 'exam2',
      component: () => import('@/page/tiku/exam2.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiku/examCard',
      name: 'examCard',
      component: () => import('@/page/tiku/examCard.vue'),
      meta: {
      }
    },

    {
      path: '/h5/my/perfec',
      name: 'perfec',
      component: () => import('@/page/my/perfec.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/activation',
      name: 'activation',
      component: () => import('@/page/my/activation.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/commentNews',
      name: 'commentNews',
      component: () => import('@/page/my/commentNews.vue'),
      meta: {
      }
    },

    {
      path: '/h5/my/info',
      name: 'info',
      component: () => import('@/page/my/info.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/editName',
      name: 'editName',
      component: () => import('@/page/my/editName.vue'),
      meta: {
      }
    }, {
      path: '/h5/my/editPassword',
      name: 'editPassword',
      component: () => import('@/page/my/editPassword.vue'),
      meta: {
      }
    },

    {
      path: '/h5/my/opinion',
      name: 'opinion',
      component: () => import('@/page/my/opinion.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/news',
      name: 'news',
      component: () => import('@/page/my/news.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/follow',
      name: 'follow',
      component: () => import('@/page/my/follow.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/order',
      name: 'order',
      component: () => import('@/page/my/order.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/orderEditAddress',
      name: 'orderEditAddress',
      component: () => import('@/page/my/orderEditAddress.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/orderRecord',
      name: 'orderRecord',
      component: () => import('@/page/my/orderRecord.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/order_detail',
      name: 'order_detail',
      component: () => import('@/page/my/order_detail.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/coupon',
      name: 'coupon',
      component: () => import('@/page/my/coupon.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/couponExplain',
      name: 'couponExplain',
      component: () => import('@/page/my/couponExplain.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/set',
      name: 'myset',
      component: () => import('@/page/my/set.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/service',
      name: 'service',
      component: () => import('@/page/my/service.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/problemListPage',
      name: 'problemListPage',
      component: () => import('@/page/my/problemListPage.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/problem_detail',
      name: 'problem_detail',
      component: () => import('@/page/my/problem_detail.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/examProblem',
      name: 'examProblem',
      component: () => import('@/page/my/examProblem.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/school',
      name: 'school',
      component: () => import('@/page/my/school.vue'),
      meta: {
      }
    }, {
      path: '/h5/my/major',
      name: 'major',
      component: () => import('@/page/my/major.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/Company',
      name: 'Company',
      component: () => import('@/page/my/Company.vue'),
      meta: {
      }
    },
    {
      path: '/h5/my/hospital',
      name: 'hospital',
      component: () => import('@/page/my/hospital.vue'),
      meta: {
      }
    }, {
      path: '/h5/recommend/index',
      name: 'recommend',
      component: () => import('@/page/recommend/index.vue'),
      meta: {
      }
    },
    {
      path: '/h5/forum/posts',
      name: 'forum',
      component: () => import('@/page/forum/posts.vue'),
      meta: {
      }
    },

    {
      path: '/h5/forum/topic',
      name: 'topic',
      component: () => import('@/page/forum/topic.vue'),
      meta: {
      }
    },
    {
      path: '/h5/index/index',
      name: 'index',
      component: () => import('@/page/index/index.vue'),
      meta: {
      }
    },
    {
      path: '/h5/sheet/more',
      name: 'sheet',
      component: () => import('@/page/index/sheetMore.vue'),
      meta: {
      }
    },
    {
      path: '/h5/ranking/sheet',
      name: 'ranking',
      component: () => import('@/page/ranking/sheet.vue'),
      meta: {
      }
    },
    {
      path: '/h5/index/manMachinePC',
      name: 'manMachinePC',
      component: () => import('@/page/index/manMachinePC.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tidan/clearanceExam',
      name: 'clearanceExam',
      component: () => import('@/page/tiDan/clearanceExam.vue'),
      meta: {
      }
    },
    {
      path: '/h5/Retest/category',
      name: 'category',
      component: () => import('@/page/Retest/category.vue'),
      meta: {
      }
    },
    {
      path: '/h5/Retest/info',
      name: 'Retestinfo',
      component: () => import('@/page/Retest/info.vue'),
      meta: {
      }
    },
    {
      path: '/h5/Retest/explain',
      name: 'Retestexplain',
      component: () => import('@/page/Retest/explain.vue'),
      meta: {
      }
    },
    {
      path: '/h5/Retest/first_try',
      name: 'Retestfirst_try',
      component: () => import('@/page/Retest/first_try.vue'),
      meta: {
      }
    },
    {
      path: '/h5/Retest/first_try_detail',
      name: 'first_try_detail',
      component: () => import('@/page/Retest/first_try_detail.vue'),
      meta: {
      }
    },
    {
      path: '/h5/ranking/ranking',
      name: 'explainranking',
      component: () => import('@/page/ranking/ranking.vue'),
      meta: {
      }
    },

    {
      path: '/h5/Retest/index',
      name: 'Retestindex',
      component: () => import('@/page/Retest/index.vue'),
      meta: {
      }
    },
    {
      path: '/h5/Retest/adjust',
      name: 'adjust',
      component: () => import('@/page/Retest/adjust.vue'),
      meta: {
      }
    },
    {
      path: '/h5/Retest/school',
      name: 'Retestschool',
      component: () => import('@/page/Retest/school.vue'),
      meta: {
      }
    },
    {
      path: '/h5/Retest/rankingHome',
      name: 'rankingHome',
      component: () => import('@/page/Retest/rankingHome.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tidan/clearanceColl',
      name: 'clearanceColl',
      component: () => import('@/page/tiDan/clearanceColl.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiDan/wrong',
      name: 'wrong',
      component: () => import('@/page/tiDan/wrong.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiDan/note',
      name: 'note',
      component: () => import('@/page/tiDan/note.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiDan/coll',
      name: 'coll',
      component: () => import('@/page/tiDan/coll.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiDan/comment',
      name: 'tiDancomment',
      component: () => import('@/page/tiDan/comment.vue'),
      meta: {
      }
    },
    {
      path: '/h5/tiDan/necessary',
      name: 'necessary',
      component: () => import('@/page/tiDan/necessary.vue'),
      meta: {
      }
    },
    {
      path: '/h5/course/index',
      name: 'courseIndex',
      component: () => import('@/page/course/index.vue'),
      meta: {
      }
    },

    {
      path: '/h5/getCoupon',
      name: 'getCoupon',
      component: () => import('@/page/getCoupon.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/getCoupon2',
      name: 'getCoupon2',
      component: () => import('@/page/goods/getCoupon2.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/test/skip',
      name: 'skip',
      component: () => import('@/page/test/skip.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/couponGoodsList',
      name: 'couponGoodsList2',
      component: () => import('@/page/goods/couponGoodsList.vue'),
      meta: {
        is_login: true
      }
    },
    {
      path: '/h5/answerCode',
      name: 'answerCode2',
      component: () => import('@/page/answerCode.vue'),
      meta: {
        is_login: true
      }
    },
  ],
  mode: 'history'
})

function get_setting_info() {
  let setting_info = localStorage.getItem('setting_info');
  if (setting_info) {
    return
  }
  Vue.prototype.$axios.get("/home/get_setting_info").then((res) => {
    if (res.code == 200) {
      localStorage.setItem('setting_info', JSON.stringify(res.data))
    }
  });
}

function getCode(code) {
  if (typeof code == "object") {
    return code[code.length - 1]
  } else {
    return code
  }
}
router.afterEach((to, from) => {
  vant.Toast.clear();
  get_setting_info();

  let wxLogin = () => {
    if (localStorage.getItem('openid')) {
      return
    }
    if (to.query.code) {
      console.log(getCode(to.query.code));
      Vue.prototype.$axios
        .get("/wechat/get_access_token", {
          params: {
            code: getCode(to.query.code),
          }
        })
        .then((res) => {
          if (res.code == 200) {
            localStorage.setItem('openid', res.data.openid);
            localStorage.setItem('big_user_id', res.data.big_user_id);
            localStorage.setItem('access_token', res.data.access_token);
            localStorage.setItem('avatar', res.data.avatar);
            localStorage.setItem('nickname', res.data.nickname);
            // localStorage.setItem('app_id',res.data.app_id);
            if (res.data.app_id) {
              localStorage.setItem('user_id', JSON.stringify(res.data.user_id));
            }
            router.app.$store.commit('setloginStatus', true)
            // location.reload();
          }
        });
    }
  }
  {
    // if (to.query.app_id) {
    //   localStorage.setItem("app_id", to.query.app_id);
    // }
    // if (to.query.app_type) {
    //   localStorage.setItem("app_type", to.query.app_type);
    // }
    // if (to.query.bundle_id) {
    //   localStorage.setItem("bundle_id", to.query.bundle_id);
    // }
  }
  document.title = '蓝基因'
  wxLogin()
  // shareHide();
})
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    location.assign(targetPath)
  }
});
router.beforeEach((to, from, next) => {
  if (to.path == from.path) {
    vant.Toast.clear();
  }
  if (to.meta.is_login) {
    next();
  } else {
    let user_info = localStorage.getItem("user_info")
    if (user_info) {
      next();
    } else {
      if (to.path !== '/h5/login' && to.path == '/h5/index/index') {
        next({
          path: '/h5/login'
        })
      } else {
        next();
      }
    }
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js